import React, {useState} from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image, Dimensions, TextInput , Modal} from "react-native";


import {RFValue} from "react-native-responsive-fontsize";
import {FontAwesome6, Ionicons} from "@expo/vector-icons";
import Config from "../../Config";
import AntDesign from "@expo/vector-icons/AntDesign";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../Components/Toast";
import toast from "../Components/Toast";






const Profile =({navigation})=>{

    let [data, setData] = useState(false);

    let[name,setName]=useState('');
    let[phone,setPhone]=useState('');
    let[avatar,setAvatar]=useState('');
    let[gender,setGender]=useState('');
    let[email,setEmail]=useState('');
    let[avatars,setAvatats]=useState([]);

    React.useEffect(() => {
        getData();
    },[]);
    let getData = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/home`,{ 'headers': {  Authorization: 'Bearer '+token} });
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            setName(res.data.user.name);
            setPhone(res.data.user.phone);
            setAvatar(res.data.user.avatar);
            setGender(res.data.user.gender);
            setEmail(res.data.user.email);
            setAvatats(res.data.avatars);

        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }

    const SendData = async ()=>{

        if(!name){
            toast('نام را وارد کنید');
            return false;
        }


        try {
            let token = await AsyncStorage.getItem('token');


            let formData = new FormData();
            formData.append('name', name);
            formData.append('avatar', avatar);
            formData.append('email', email);
            formData.append('gender', gender);

            let resss = await axios.post(
                `${Config.api}/user/profile`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": 'Bearer '+token
                    }
                }
            );

            if(resss.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            toast('اطلاعات با موفقیت بروز شد');
        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    };


    const [isModalVisible, setModalVisible] = useState(false);

    const toggleModal = () => {
        setModalVisible(!isModalVisible);
    };




    return (
        <View style={styles.container}>


            <Modal
                transparent={true}
                visible={isModalVisible}
                animationType="slide"
                onRequestClose={toggleModal} // برای بستن مودال در اندروید با دکمه بازگشت
            >
                <View style={styles.modalOverlay}>
                    <View style={styles.modalContent}>
                        <View style={styles.avatars}>
                            {avatars.map( (ava,index)=>
                                <TouchableOpacity key={index} onPress={()=>{
                                    setAvatar(ava);
                                    toggleModal();
                                }}>
                                    <Image   style={styles.imageava}  source={{uri : `${Config.base}/${ava}`}} />
                                </TouchableOpacity>

                            )}

                        </View>
                        <TouchableOpacity style={styles.closeButton} onPress={toggleModal}>
                            <Text style={styles.closeButtonText}>بستن صفحه</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>


            <View style={styles.header}>
                <TouchableOpacity style={{flex : 1}} >
                    <Text style={styles.title}>
                      پروفایل من
                    </Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={()=>{navigation.goBack()}}>
                    <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />
                </TouchableOpacity>
            </View>
            <ScrollView style={{flex:1  , backgroundColor : Config.maincolor}}>
                <View style={styles.content}>
                    <TouchableOpacity style={styles.imagearea}  onPress={toggleModal} >
                        <Image style={styles.image}  source={{uri : `${Config.base}/${avatar}`}} />
                        <AntDesign style={styles.camera} name="camera" size={RFValue(18)} color="#FFF" />
                    </TouchableOpacity>

                    <Text style={styles.label}>
                        نام و نام خانوادگی
                    </Text>
                    <View style={styles.input}>
                        <TextInput
                            value={name}
                            onChangeText={setName}

                            placeholderTextColor={'white'}
                            placeholder={'نام خود را وارد کنید'}

                            style={{direction : 'rtl',width : '100%',fontFamily : 'yk',textAlign : 'right'  , letterSpacing : 1 , backgroundColor : '#1B2048' , color : 'white'}}
                            keyboardType={'default'}
                            maxLength={11}
                        />
                    </View>

                    <Text style={styles.label}>
                        شماره موبایل
                    </Text>
                    <View style={styles.input}>
                        <TextInput

                            value={phone}
                            editable={false}

                            placeholderTextColor={'white'}
                            placeholder={'شماره موبایل خود را وارد کنید'}

                            style={{direction : 'rtl',width : '100%',fontFamily : 'yk',textAlign : 'right'  , letterSpacing : 1 , backgroundColor : '#1B2048' , color:'white' }}
                            keyboardType={'numeric'}
                            maxLength={11}
                        />
                    </View>
                    <Text style={styles.label}>
                     ایمیل
                    </Text>
                    <View style={styles.input}>
                        <TextInput

                            value={email}
                            onChangeText={setEmail}

                            placeholderTextColor={'white'}
                            placeholder={'ایمیل خود را وارد کنید'}

                            style={{direction : 'rtl',width : '100%',fontFamily : 'yk',textAlign : 'right'  , letterSpacing : 1 , backgroundColor : '#1B2048' , color:'white' }}
                            keyboardType={'email-address'}
                            maxLength={30}
                        />
                    </View>
                    <Text style={styles.label}>
                       جنسیت
                    </Text>
                    <View style={styles.radiorow}>

                        {gender == 1 ?
                            <>
                                <TouchableOpacity style={styles.radioline} >
                                    <AntDesign name="checkcircle" size={RFValue(14)} color="#33B300" />
                                    <Text style={styles.radiotxt}>مذکر</Text>
                                </TouchableOpacity>

                                <TouchableOpacity style={styles.radioline} onPress={()=>{setGender(2)}}>
                                    <FontAwesome6 name="circle" size={RFValue(14)} color="white" />
                                    <Text style={styles.radiotxt}>مونث</Text>
                                </TouchableOpacity>
                            </>
                            :
                            <>
                                <TouchableOpacity style={styles.radioline} onPress={()=>{setGender(1)}}>
                                    <FontAwesome6 name="circle" size={RFValue(14)} color="white" />
                                    <Text style={styles.radiotxt}>مذکر</Text>
                                </TouchableOpacity>

                                <TouchableOpacity style={styles.radioline}>

                                    <AntDesign name="checkcircle" size={RFValue(14)} color="#33B300" />
                                    <Text style={styles.radiotxt}>مونث</Text>
                                </TouchableOpacity>
                            </>
                        }
                    </View>

                    <View style={{flex: 1, justifyContent: 'center'}}>
                        <TouchableOpacity   onPress={SendData} style={styles.button}>
                            <Text style={styles.buttonText}>بروزرسانی اطلاعات </Text>
                        </TouchableOpacity>
                    </View>



                </View>
            </ScrollView>


        </View>
    );
}

const styles = StyleSheet.create({



    buttonText : {
        fontFamily : 'ykb',
        fontSize : RFValue(16),
        color : Config.maincolor,
    },
    button : {
        backgroundColor: Config.secondcolor,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop : RFValue(35),
        borderRadius : RFValue(30),
        height : RFValue(40),

    },

    radiotxt : {
        fontSize: RFValue(14),
        marginRight : RFValue(5),
        fontFamily: 'yk',
        color: 'white',
    },

    radioline : {
        flexDirection : 'row',
        justifyContent : 'space-between',
        alignItems: 'center',
        marginLeft: RFValue(50),
    },

    radiorow : {
      flexDirection : 'row',
      justifyContent : 'flex-start',
      alignItems: 'center',
    },

    input :{
        borderStyle:'solid',
        borderColor:'#E7E9F2',
        borderWidth:1,
        borderRadius : RFValue(10),
        height : RFValue(50),
        paddingVertical : RFValue(1),
        paddingHorizontal : RFValue(5),
        backgroundColor: '#1B2048',

        marginTop : RFValue(0),
        justifyContent: 'center',
        alignItems: 'center',

    },

    label: {
        fontSize: RFValue(16),
        marginTop : RFValue(15),
        marginBottom : RFValue(10),
        fontFamily: 'yk',
        color: 'white',
    },

    imagearea: {
      justifyContent: 'center',
        alignItems: 'center',

    },

    image : {
      width : RFValue(115),
        height : RFValue(115),
        borderRadius : RFValue(55),
        borderColor : Config.secondcolor,
        borderWidth : 1,
    },
    camera : {
        marginTop : -RFValue(14),
        borderRadius : RFValue(30),
        borderColor : 'white',
        borderWidth : 1,
        padding : RFValue(5),
        backgroundColor : Config.maincolor
    },



    content : {
        flex: 1,
        paddingHorizontal: RFValue(20),
        justifyContent: "center",
        paddingVertical: RFValue(20),
        backgroundColor : Config.maincolor,
    },

    container : {
        flex: 1,
        backgroundColor: '#FAFAFA',
    },
    header: {
        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: '#FFF',
        paddingVertical: RFValue(14),

    },


    modalOverlay: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // برای پس‌زمینه تاریک
    },
    modalContent: {
        width: RFValue(260),
        padding: RFValue(5),
        backgroundColor: 'white',
        borderRadius: 10,
        alignItems: 'center',
    },
    modalText: {
        fontSize: 18,
        marginBottom: 20,
    },
    closeButton: {
        paddingVertical: 10,
        paddingHorizontal: 20,
        backgroundColor: '#007BFF',
        borderRadius: 5,
    },
    closeButtonText: {
        color: 'white',
        fontWeight: 'bold',
    },
    avatars : {
      justifyContent: 'space-between',
      alignItems: 'center',
        flexDirection: 'row',
        padding: RFValue(1),
        flexWrap : 'wrap',
    },
    imageava : {
        width : RFValue(110),
        height : RFValue(110),
        borderRadius : RFValue(55),
        margin : RFValue(2),
    },


})


export default Profile